module.exports = __webpack_public_path__ + "img/tetosBB.82ebc67c.webp";